import { render, staticRenderFns } from "./DisabledCompanyBanner.vue?vue&type=template&id=62d5545a&scoped=true&"
import script from "./DisabledCompanyBanner.vue?vue&type=script&lang=js&"
export * from "./DisabledCompanyBanner.vue?vue&type=script&lang=js&"
import style0 from "./DisabledCompanyBanner.vue?vue&type=style&index=0&id=62d5545a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d5545a",
  null
  
)

export default component.exports